import { Nullish } from '@payaca/utilities/types';

interface SubscriptionProductFeatures {
  numberOfUserSeats?: number;
  numberOfSmsPerMonth?: number;
}
export interface SubscriptionProduct extends SubscriptionProductFeatures {
  stripeId: string;
  tier: string;
  description?: string;
  monthlyPrice?: ProductPrice;
  annualPrice?: ProductPrice;
  discountPercentage?: Nullish<number>;
  discountDurationInMonths?: Nullish<number>;
  discountRedeemBy?: Nullish<number>;
}

export interface SubscriptionProductInformation extends SubscriptionProductFeatures {
  id: number;
  productId: string;
  tier: string;
}
export interface TemporarySubscriptionProduct extends SubscriptionProduct {
  expiresAt: string;
}

export interface ProductPrice {
  stripeId: string;
  basicCost: number;
  additionalUserSeatCost?: number;
  canBuyAdditionalUserSeats: boolean;
}

export enum RecurringInterval {
  MONTH = 'month',
  YEAR = 'year',
}
